import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { isEmpty, isNil, times } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import PaginationRow from 'components/atoms/GefMui/PaginationRow';
import TableHasNoResults from 'components/atoms/GefMui/TableHasNoResults';
import fetch from 'features/common/fetch';
import { loadeMore, searchUser } from 'features/views/userSearch/actions';

import Row from './Row';

export const ResultsTable = ({ users, onSelect, formData }) => {
	const dispatch = useDispatch();
	const { queryParams: lastQueryParams } = useSelector(fetch.selectors.getLastRequest(fetch.constants.urls.userList));

	const renderEmptyRow = () => (
		<TableRow>
			{times(
				(i) => (
					<TableCell key={i}>---</TableCell>
				),
				4,
			)}
		</TableRow>
	);

	const handleLoadMore = useCallback(() => {
		// workaround to ensure back compatibility with old pagination when old non MUI pages use userSearch loadMore
		// todo - unify after all taskCreating pages MUI refactor done
		const { page } = lastQueryParams;
		dispatch(loadeMore(formData, page + 1));
	}, [dispatch, formData, lastQueryParams]);

	const handlePaginationClick = useCallback(
		(e, page) => {
			dispatch(searchUser({ formData, page: page - 1 }));
		},
		[dispatch, formData],
	);

	return (
		<Table size="small">
			<TableHead>
				<TableRow>
					<TableCell>{getLabelMessage('userSearch:firstName')}</TableCell>
					<TableCell>{getLabelMessage('userSearch:login')}</TableCell>
					<TableCell>{getLabelMessage('userSearch:sellerIn')}</TableCell>
					<TableCell>{getLabelMessage('userSearch:profession')}</TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{isNil(users) ? (
					renderEmptyRow()
				) : isEmpty(users) ? (
					<TableHasNoResults />
				) : (
					users.map((user, index) => (
						<TableRow key={`${user.surname}${index}`}>
							<Row user={user} onSelect={onSelect} index={index} />
						</TableRow>
					))
				)}
			</TableBody>
			<PaginationRow
				fetchStorePath={fetch.constants.urls.userList}
				onLoadNext={handleLoadMore}
				onPaginationClick={handlePaginationClick}
				hideOnResultsLimit
			/>
		</Table>
	);
};

ResultsTable.propTypes = {
	formData: PropTypes.object,
	onSelect: PropTypes.func,
	users: PropTypes.array,
};

export default ResultsTable;
